import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "create-template-block" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-lg-9 offset-lg-3" }, [
    /*#__PURE__*/_createVNode("div", { class: "inner-wrap pt-0" }, [
      /*#__PURE__*/_createVNode("h1", { class: "title" }, "create template")
    ])
  ])
], -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-3" }
const _hoisted_5 = { class: "form-element-wrapper block-list" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Section ")
const _hoisted_7 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Text field ")
const _hoisted_9 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Textarea ")
const _hoisted_11 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Select ")
const _hoisted_13 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Radio ")
const _hoisted_15 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" checkbox ")
const _hoisted_17 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_18 = { class: "col-lg-9" }
const _hoisted_19 = {
  key: 0,
  class: "card drag-wrapper"
}
const _hoisted_20 = { class: "form-wrap pt-0" }
const _hoisted_21 = { class: "form-title" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createVNode("p", null, "Create Form", -1)
const _hoisted_24 = { class: "modal-wrap form-edit" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("x ")
const _hoisted_26 = {
  class: "modal fade",
  id: "beforeAdd",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_27 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_28 = { class: "modal-content" }
const _hoisted_29 = { class: "modal-header" }
const _hoisted_30 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_32 = { class: "modal-body" }
const _hoisted_33 = { class: "form-wrap pt-0" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Description", -1)
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_42 = { key: 2 }
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_45 = { key: 3 }
const _hoisted_46 = { class: "form-wrap pt-0" }
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_49 = {
  key: 0,
  class: "form-group"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_51 = { class: "col-lg-1" }
const _hoisted_52 = { class: "form-check custom-control custom-radio" }
const _hoisted_53 = /*#__PURE__*/_createVNode("label", {
  class: "custom-control-label",
  for: "exampleRadios1"
}, null, -1)
const _hoisted_54 = { class: "col-lg-5" }
const _hoisted_55 = { class: "col-lg-5" }
const _hoisted_56 = { class: "col-lg-1 pl-0" }
const _hoisted_57 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_58 = { class: "text-right" }
const _hoisted_59 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_61 = { key: 4 }
const _hoisted_62 = { class: "form-wrap pt-0" }
const _hoisted_63 = { class: "form-group" }
const _hoisted_64 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_65 = {
  key: 0,
  class: "form-group"
}
const _hoisted_66 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_67 = { class: "col-lg-1" }
const _hoisted_68 = { class: "form-check custom-control custom-radio" }
const _hoisted_69 = /*#__PURE__*/_createVNode("label", {
  class: "custom-control-label",
  for: "exampleRadios1"
}, null, -1)
const _hoisted_70 = { class: "col-lg-5" }
const _hoisted_71 = { class: "col-lg-5" }
const _hoisted_72 = { class: "col-lg-1 pl-0" }
const _hoisted_73 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_74 = { class: "text-right" }
const _hoisted_75 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_77 = { key: 5 }
const _hoisted_78 = { class: "form-wrap pt-0" }
const _hoisted_79 = { class: "form-group" }
const _hoisted_80 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_81 = {
  key: 0,
  class: "form-group"
}
const _hoisted_82 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_83 = { class: "col-lg-1" }
const _hoisted_84 = { class: "form-check custom-control custom-radio" }
const _hoisted_85 = /*#__PURE__*/_createVNode("label", {
  class: "custom-control-label",
  for: "exampleRadios1"
}, null, -1)
const _hoisted_86 = { class: "col-lg-5" }
const _hoisted_87 = { class: "col-lg-5" }
const _hoisted_88 = { class: "col-lg-1 pl-0" }
const _hoisted_89 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_90 = { class: "text-right" }
const _hoisted_91 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_93 = { class: "form-group" }
const _hoisted_94 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Add at", -1)
const _hoisted_95 = /*#__PURE__*/_createVNode("option", { selected: "" }, "Select", -1)
const _hoisted_96 = /*#__PURE__*/_createVNode("option", { value: "top" }, "Top", -1)
const _hoisted_97 = /*#__PURE__*/_createVNode("option", { value: "bottom" }, "Bottom", -1)
const _hoisted_98 = { class: "modal-footer" }
const _hoisted_99 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}, " Close ", -1)
const _hoisted_100 = /*#__PURE__*/_createVNode("div", { class: "modal-wrap form-edit" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "modal fade",
    id: "edittext",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createVNode("div", {
      class: "modal-dialog modal-dialog-centered",
      role: "document"
    }, [
      /*#__PURE__*/_createVNode("div", { class: "modal-content" }, [
        /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
          /*#__PURE__*/_createVNode("h5", {
            class: "modal-title",
            id: "exampleModalLabel"
          }, "Edit form"),
          /*#__PURE__*/_createVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }, [
            /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
          ])
        ]),
        /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
          /*#__PURE__*/_createVNode("div", { class: "form-wrap pt-0" }, [
            /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
              /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Label"),
              /*#__PURE__*/_createVNode("input", {
                type: "text",
                class: "form-control",
                id: "inputPassword",
                placeholder: "Text field label",
                value: "How Long Would It Take To Complete This Task?"
              })
            ]),
            /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
              /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Type"),
              /*#__PURE__*/_createVNode("select", { class: "form-control custom-select" }, [
                /*#__PURE__*/_createVNode("option", { selected: "" }, "Select"),
                /*#__PURE__*/_createVNode("option", { value: "1" }, "Textfield"),
                /*#__PURE__*/_createVNode("option", { value: "2" }, "Password"),
                /*#__PURE__*/_createVNode("option", { value: "3" }, "Email")
              ])
            ]),
            /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
              /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Max length"),
              /*#__PURE__*/_createVNode("input", {
                type: "password",
                class: "form-control",
                id: "inputPassword",
                placeholder: "Text field label"
              })
            ])
          ])
        ]),
        /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
          /*#__PURE__*/_createVNode("button", {
            type: "button",
            class: "btn secondary-btn",
            "data-dismiss": "modal"
          }, " Close "),
          /*#__PURE__*/_createVNode("button", {
            type: "button",
            class: "btn default-btn"
          }, "Save changes")
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleComponent = _resolveComponent("TitleComponent")
  const _component_TextBoxComponent = _resolveComponent("TextBoxComponent")
  const _component_RadioButtonComponent = _resolveComponent("RadioButtonComponent")
  const _component_SelectOption = _resolveComponent("SelectOption")
  const _component_CheckBox = _resolveComponent("CheckBox")
  const _component_TextArea = _resolveComponent("TextArea")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("ul", null, [
              _createVNode("li", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTextFieldAdd('title', 'Title')))
              }, [
                _hoisted_6,
                _hoisted_7
              ]),
              _createVNode("li", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTextFieldAdd('textbox', 'Text Box')))
              }, [
                _hoisted_8,
                _hoisted_9
              ]),
              _createVNode("li", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showTextFieldAdd('textArea', 'TextArea')))
              }, [
                _hoisted_10,
                _hoisted_11
              ]),
              _createVNode("li", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showTextFieldAdd('single_select', 'Select Option')))
              }, [
                _hoisted_12,
                _hoisted_13
              ]),
              _createVNode("li", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showTextFieldAdd('radioButton', 'Radio Button')))
              }, [
                _hoisted_14,
                _hoisted_15
              ]),
              _createVNode("li", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showTextFieldAdd('checkBox', 'Check Box')))
              }, [
                _hoisted_16,
                _hoisted_17
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          (_ctx.state.data && _ctx.state.data.length)
            ? (_openBlock(), _createBlock("div", _hoisted_19, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data, (form, formIndex) => {
                  return (_openBlock(), _createBlock("div", { key: formIndex }, [
                    (form.type === 'title')
                      ? (_openBlock(), _createBlock(_component_TitleComponent, {
                          key: 0,
                          title: form.title,
                          description: form.description,
                          editStatus: true
                        }, null, 8, ["title", "description"]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_20, [
                      (form.type === 'textbox')
                        ? (_openBlock(), _createBlock(_component_TextBoxComponent, {
                            key: 0,
                            data: form,
                            editStatus: true
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true),
                      (form.type === 'radioButton')
                        ? (_openBlock(), _createBlock(_component_RadioButtonComponent, {
                            key: 1,
                            data: form,
                            editStatus: true
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true),
                      (form.type === 'single_select')
                        ? (_openBlock(), _createBlock(_component_SelectOption, {
                            key: 2,
                            data: form
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true),
                      (form.type === 'checkBox')
                        ? (_openBlock(), _createBlock(_component_CheckBox, {
                            key: 3,
                            data: form
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true),
                      (form.type === 'textArea')
                        ? (_openBlock(), _createBlock(_component_TextArea, {
                            key: 4,
                            data: form,
                            editStatus: true
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128)),
                _createVNode("div", _hoisted_21, [
                  _createVNode("button", {
                    class: "btn default-btn",
                    disabled: !_ctx.state.data || !_ctx.state.data.length,
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.createFormTemplate && _ctx.createFormTemplate(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.createFormTemplate ? 'Creating...' :'Create Form'), 9, ["disabled"])
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_22, [
                _hoisted_23
              ]))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_24, [
      _hoisted_25,
      _createVNode("div", _hoisted_26, [
        _createVNode("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            _createVNode("div", _hoisted_29, [
              _createVNode("h5", _hoisted_30, " Add " + _toDisplayString(_ctx.state.selected), 1),
              _hoisted_31
            ]),
            _createVNode("div", _hoisted_32, [
              _createVNode("div", _hoisted_33, [
                (_ctx.state.type === 'title')
                  ? (_openBlock(), _createBlock("div", _hoisted_34, [
                      _createVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.form.textField.title = $event)),
                          type: "text",
                          class: "form-control",
                          id: "inputPassword",
                          placeholder: "Title Here"
                        }, null, 512), [
                          [_vModelText, _ctx.state.form.textField.title]
                        ])
                      ]),
                      _createVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.form.textField.description = $event)),
                          type: "text",
                          class: "form-control",
                          id: "inputPassword",
                          placeholder: "Description here"
                        }, null, 512), [
                          [_vModelText, _ctx.state.form.textField.description]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.type === 'textbox')
                  ? (_openBlock(), _createBlock("div", _hoisted_39, [
                      _createVNode("div", _hoisted_40, [
                        _hoisted_41,
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.form.textbox.title = $event)),
                          type: "text",
                          class: "form-control",
                          id: "inputPassword",
                          placeholder: "Title Here"
                        }, null, 512), [
                          [_vModelText, _ctx.state.form.textbox.title]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.type === 'textArea')
                  ? (_openBlock(), _createBlock("div", _hoisted_42, [
                      _createVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.form.textArea.title = $event)),
                          type: "text",
                          class: "form-control",
                          id: "inputPassword",
                          placeholder: "Title Here"
                        }, null, 512), [
                          [_vModelText, _ctx.state.form.textArea.title]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.type === 'radioButton')
                  ? (_openBlock(), _createBlock("div", _hoisted_45, [
                      _createVNode("div", _hoisted_46, [
                        _createVNode("div", _hoisted_47, [
                          _hoisted_48,
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "inputPassword",
                            placeholder: "Text field label",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.form.radioButton.title = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.form.radioButton.title]
                          ])
                        ]),
                        (
                      _ctx.state.form.radioButton.select_values &&
                      _ctx.state.form.radioButton.select_values.length
                    )
                          ? (_openBlock(), _createBlock("div", _hoisted_49, [
                              _hoisted_50,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.form.radioButton
                        .select_values, (row, rowIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "row py-2",
                                  key: rowIndex
                                }, [
                                  _createVNode("div", _hoisted_51, [
                                    _createVNode("div", _hoisted_52, [
                                      _withDirectives(_createVNode("input", {
                                        class: "custom-control-input",
                                        type: "radio",
                                        name: "exampleRadios",
                                        id: "exampleRadios1",
                                        checked: "",
                                        "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelRadio, row.selected]
                                      ]),
                                      _hoisted_53
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_54, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option label",
                                      "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.text]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_55, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option value",
                                      "onUpdate:modelValue": ($event: any) => (row.value = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.value]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_56, [
                                    _createVNode("button", {
                                      type: "button",
                                      class: "option-btn",
                                      onClick: ($event: any) => (_ctx.removeOptions(row.text))
                                    }, [
                                      _hoisted_57
                                    ], 8, ["onClick"])
                                  ])
                                ]))
                              }), 128)),
                              _createVNode("div", _hoisted_58, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.addOptions && _ctx.addOptions(...args))),
                                  class: "btn default-btn outline secondary mt-3"
                                }, [
                                  _hoisted_59,
                                  _hoisted_60
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.type === 'single_select')
                  ? (_openBlock(), _createBlock("div", _hoisted_61, [
                      _createVNode("div", _hoisted_62, [
                        _createVNode("div", _hoisted_63, [
                          _hoisted_64,
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "inputPassword",
                            placeholder: "Text field label",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.state.form.selectOption.title = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.form.selectOption.title]
                          ])
                        ]),
                        (
                      _ctx.state.form.selectOption.select_values &&
                      _ctx.state.form.selectOption.select_values.length
                    )
                          ? (_openBlock(), _createBlock("div", _hoisted_65, [
                              _hoisted_66,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.form.selectOption
                        .select_values, (row, rowIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "row py-2",
                                  key: rowIndex
                                }, [
                                  _createVNode("div", _hoisted_67, [
                                    _createVNode("div", _hoisted_68, [
                                      _withDirectives(_createVNode("input", {
                                        class: "custom-control-input",
                                        type: "radio",
                                        name: "exampleRadios",
                                        id: "exampleRadios1",
                                        checked: "",
                                        "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelRadio, row.selected]
                                      ]),
                                      _hoisted_69
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_70, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option label",
                                      "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.text]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_71, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option value",
                                      "onUpdate:modelValue": ($event: any) => (row.value = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.value]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_72, [
                                    _createVNode("button", {
                                      type: "button",
                                      class: "option-btn",
                                      onClick: ($event: any) => (_ctx.removeSelectOption(row.text))
                                    }, [
                                      _hoisted_73
                                    ], 8, ["onClick"])
                                  ])
                                ]))
                              }), 128)),
                              _createVNode("div", _hoisted_74, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.addSelectOptions && _ctx.addSelectOptions(...args))),
                                  class: "btn default-btn outline secondary mt-3"
                                }, [
                                  _hoisted_75,
                                  _hoisted_76
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.type === 'checkBox')
                  ? (_openBlock(), _createBlock("div", _hoisted_77, [
                      _createVNode("div", _hoisted_78, [
                        _createVNode("div", _hoisted_79, [
                          _hoisted_80,
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "inputPassword",
                            placeholder: "Text field label",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.state.form.checkBox.title = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.form.checkBox.title]
                          ])
                        ]),
                        (
                      _ctx.state.form.checkBox.select_values &&
                      _ctx.state.form.checkBox.select_values.length
                    )
                          ? (_openBlock(), _createBlock("div", _hoisted_81, [
                              _hoisted_82,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.form.checkBox
                        .select_values, (row, rowIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "row py-2",
                                  key: rowIndex
                                }, [
                                  _createVNode("div", _hoisted_83, [
                                    _createVNode("div", _hoisted_84, [
                                      _withDirectives(_createVNode("input", {
                                        class: "custom-control-input",
                                        type: "radio",
                                        name: "exampleRadios",
                                        id: "exampleRadios1",
                                        checked: "",
                                        "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelRadio, row.selected]
                                      ]),
                                      _hoisted_85
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_86, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option label",
                                      "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.text]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_87, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option value",
                                      "onUpdate:modelValue": ($event: any) => (row.value = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.value]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_88, [
                                    _createVNode("button", {
                                      type: "button",
                                      class: "option-btn",
                                      onClick: ($event: any) => (_ctx.removeCheckBox(row.text))
                                    }, [
                                      _hoisted_89
                                    ], 8, ["onClick"])
                                  ])
                                ]))
                              }), 128)),
                              _createVNode("div", _hoisted_90, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.addCheckBox && _ctx.addCheckBox(...args))),
                                  class: "btn default-btn outline secondary mt-3"
                                }, [
                                  _hoisted_91,
                                  _hoisted_92
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_93, [
                  _hoisted_94,
                  _withDirectives(_createVNode("select", {
                    class: "form-control custom-select",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.state.typePosition = $event))
                  }, [
                    _hoisted_95,
                    _hoisted_96,
                    _hoisted_97
                  ], 512), [
                    [_vModelSelect, _ctx.state.typePosition]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_98, [
              _hoisted_99,
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.addTextField && _ctx.addTextField(...args)))
              }, " Add ")
            ])
          ])
        ])
      ])
    ]),
    _hoisted_100
  ]))
}